// extracted by mini-css-extract-plugin
export default {"downloadBtn":"ledgerTableActions_downloadBtn__yUvpR"};